(function () {
	'use strict';

	angular.module('mx.components').directive('mxContainer', function mxContainerDirective() {
		return {
			require: {
				mxParentContainerCtrl: '?^^mxContainer',
			},
			restrict: 'A',
			scope: false,
			bindToController: true,
			priority: 1000, // higher than for `ng-if`

			controller: [
				'$scope',
				'$element',
				'$attrs',
				function ($scope, $element, $attrs) {
					const vm = this;
					let mxContainerEl;

					const innerVisibleChildren = [];
					let isVisibleState = true;
					const hiddenWrapperHtmlClass = 'mx-container-wrapper--hide-if-empty--hidden';
					const hiddenContainerHtmlClass = 'mx-container--hide-if-empty--hidden';

					const hasNgIf = !!$attrs.ngIf; // means if property `Visibility` is set

					const _debouncedHandleVisibility = $.debounce(200, () => _handleVisibility());

					if (hasNgIf) {
						if ($attrs.ngIf === 'false') {
							// for optimization
							_hideWrappers();
						} else {
							$scope.$watch($attrs.ngIf, (ngIfValue) => {
								if (ngIfValue) {
									_showWrappers();
									// In a case this mxContainer has ng-if then $element will be html-comment (like this: "<!-- ngIf: ... -->", means not like this: "<div mx-container ng-if />")
									// and because of mxContainer directive has higher priority than ngIf divective
									// for this moment ngIf has not created "<div mx-container ng-if />" element yet
									// so we have to wait next cycle using `$evalAsync`
									// and then get real element (like "<div mx-container ng-if />") using method next().
									$scope.$evalAsync(() => {
										mxContainerEl = $element.next(`[ng-if="${$attrs.ngIf}"]`);
										vm.hideIfEmpty = _isHideIfEmpty(mxContainerEl);
										mxContainerEl.__mxContainerRegistrationId = _generateContainerId($element);
										_init(mxContainerEl);
									});
								} else {
									_hideWrappers(mxContainerEl);
								}
							});
						}
					} else {
						mxContainerEl = $element;
						vm.hideIfEmpty = _isHideIfEmpty(mxContainerEl);
					}

					vm.$onInit = function () {
						if (!hasNgIf) {
							/* if doesn't have ng-if because $element would be html-comment (like "<!-- ngIf: ... -->"). Its registration not here but in ngIf $watcher */
							_init(mxContainerEl);
						}
					};

					// Handle this Container visibility on Children init and destroy
					// param: "idObject" (identifying object) is a $scope or an $element (if component doesn't have own $scope)
					//		   which is needed for identifying and for observing $destroy events
					vm.registerChild = function (idObject) {
						idObject.__mxContainerRegistrationId = _generateContainerId(idObject);
						vm.setChildVisibility(idObject, true);
						(idObject.$on || idObject.on || function () {}).call(idObject, '$destroy', function () {
							vm.setChildVisibility(idObject, false);
						});
					};

					// method for manual setting of any changes in child visibility
					vm.setChildVisibility = function (idObject, isChildVisible) {
						if (vm.hideIfEmpty) {
							const childElementId = idObject.__mxContainerRegistrationId;
							let i;
							const wasEmpty = innerVisibleChildren.length === 0;
							// Register child if new
							if (isChildVisible && innerVisibleChildren.indexOf(childElementId) === -1) {
								innerVisibleChildren.push(childElementId);
							} else if (!isChildVisible && (i = innerVisibleChildren.indexOf(childElementId)) !== -1) {
								innerVisibleChildren.splice(i, 1);
							}
							const isEmpty = innerVisibleChildren.length === 0;

							if (vm.mxParentContainerCtrl && wasEmpty !== isEmpty) {
								vm.mxParentContainerCtrl.setChildVisibility(mxContainerEl, !(vm.hideIfEmpty && innerVisibleChildren.length === 0 && !_hasVisibleControls()));
							}
							_debouncedHandleVisibility();
						}
					};

					function _init(mxContainerEl) {
						if (vm.mxParentContainerCtrl) {
							vm.mxParentContainerCtrl.registerChild(mxContainerEl);
						}

						// to avoid blinking check if probably not visible
						if (vm.hideIfEmpty && mxContainerEl.find('[data-visual-type]:not(mx-search-control):not(mx-prominent-search-control)').length === 0) {
							isVisibleState = true;
							_handleVisibility();
						}
					}

					function _handleVisibility() {
						let visibleControlsAmount;
						if (!isVisibleState && (innerVisibleChildren.length || (visibleControlsAmount = _hasVisibleControls()))) {
							_showPanel();
						} else if (
							vm.hideIfEmpty &&
							isVisibleState &&
							innerVisibleChildren.length === 0 &&
							(visibleControlsAmount === 0 || (visibleControlsAmount === undefined && !_hasVisibleControls()))
						) {
							_hidePanel();
						}
					}

					function _showPanel() {
						isVisibleState = true;
						mxContainerEl.removeClass(hiddenContainerHtmlClass);
						_showWrappers();
						if (vm.mxParentContainerCtrl) {
							vm.mxParentContainerCtrl.setChildVisibility(mxContainerEl, true);
						}
					}

					function _hidePanel() {
						isVisibleState = false;
						mxContainerEl.addClass(hiddenContainerHtmlClass);
						_hideWrappers();
						if (vm.mxParentContainerCtrl) {
							vm.mxParentContainerCtrl.setChildVisibility(mxContainerEl, false);
						}
					}

					function _hasVisibleControls() {
						return !!mxContainerEl.has(
							'input,' +
								'textarea,' +
								'[data-visual-type="edit-control"],' +
								'[data-visual-type="control"]:not(.mx-literal):not(.mx-literal):not(mx-related-objects-link):not(mx-repeater):not(mx-search-control):not(mx-prominent-search-control),' +
								'.mx-control--avoid-hiding'
						).length;
					}

					function _showWrappers() {
						const wrappingMxRow = $element.parent('[mx-row]');
						wrappingMxRow.removeClass(hiddenWrapperHtmlClass);
						wrappingMxRow.parent('[mx-rows-container]').removeClass(hiddenWrapperHtmlClass);
					}

					function _hideWrappers(ngIfElement) {
						const wrapper1 = $element.parent();
						const isWrapper1MxRow = wrapper1.is('[mx-row]');
						const siblingsInWrapper1 = isWrapper1MxRow ? wrapper1.children(`:not(.${hiddenContainerHtmlClass})`) : undefined;

						if (
							isWrapper1MxRow &&
							(siblingsInWrapper1.length === 0 || (siblingsInWrapper1.length === 1 && ngIfElement && siblingsInWrapper1[0] === ngIfElement[0])) // the case when mxContainerEl is hiding by `ng-if` letter, not on init (after it had been present in the DOM)
						) {
							wrapper1.addClass(hiddenWrapperHtmlClass);
							const wrapper2 = wrapper1.parent();
							const isWrapper2MxRowsContainer = wrapper2.is('[mx-rows-container]');
							const siblingsInWrapper2 = isWrapper2MxRowsContainer ? wrapper2.children(`:not(.${hiddenWrapperHtmlClass})`).length : undefined;
							if (isWrapper2MxRowsContainer && siblingsInWrapper2 === 0) {
								wrapper2.addClass(hiddenWrapperHtmlClass);
							}
						}
					}

					function _isHideIfEmpty(mxContainerEl) {
						return mxContainerEl.attr('data-behavior') === 'hide-empty';
					}

					function _generateContainerId(idObject) {
						idObject.__mxContainerRegistrationId = idObject.__mxContainerRegistrationId || mx.components.Utils.genElemId('mx-container-child-');
						return idObject.__mxContainerRegistrationId;
					}
				},
			],
		};
	});
})();
